<template>
  <el-dialog
    class="add-role-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
    >
      <el-form-item label="角色名称" prop="Name">
        <el-input v-model="editForm.Name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="角色描述" prop="description">
        <el-input
          v-model="editForm.description"
          type="textarea"
          :resize="resize"
          :rows="3"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-switch v-model="editForm.status" active-value="normal" inactive-value="stopped">
        </el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'AddRole',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 80
  },
  data() {
    return {
      title: '新增角色',
      dialogVisible: false,
      editRule: {
        Name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        description: [{ required: true, message: '请输入角色描述', trigger: 'blur' }],
        status: [{ required: true, message: '请输入状态', trigger: 'blur' }]
      },
      editForm: {
        Name: '',
        description: '',
        status: 'normal'
      },
      resize: 'none',
      adaptationVars: {
        formLabelWidth: 80
      }
    }
  },
  methods: {
    handleOpen() {
      this.dialogVisible = true
    },
    handleCancel() {
      this.editForm = {
        Name: '',
        description: '',
        status: 'normal'
      }
      this.$refs.editForm.clearValidate()
      this.dialogVisible = false
    },
    handleOk() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$apis.system.createRole(this.editForm).then(res => {
            if (res) {
              this.$message.success('新增角色成功')
              this.handleCancel()
              this.$emit('update:list')
            }
          })
        } else {
          this.$message.warning('请完善信息')
          return
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.add-role-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
